import { chartColors, optionsStackedBar } from "./utils"

// Stacked bar chart
const figure_1_5 = {
  type: "stacked",
  figureNumber: "1.5",
  title: "Rising Debt Risks in Low-Income Countries",
  subTitle: "(percent of DSSI countries with LIC DSAs)",
  caption: "The proportion of countries in debt distress, or at high risk of debt distress has doubled to 60 percent from 2015 levels.",
  source: "Source: LIC DSA database. /n * Note: As of March 31, 2022. DSSI = Debt service suspension initiative; LIC = Low-income countries; DSAs = Debt sustainability analyses.",
  data: {
    labels: [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
    ],
    datasets: [
      {
        label: "Low",
        borderColor: chartColors(0),
        backgroundColor: chartColors(0),
        data: [
          28, 33, 33, 35, 33, 30, 24, 21, 17, 17, 19, 15, 10, 10,
        ],
        barThickness: 12,
      },
      {
        label: "Moderate",
        borderColor: chartColors(1),
        backgroundColor: chartColors(1),
        data: [
          37, 36, 35, 38, 46, 45, 50, 47, 39, 35, 31, 33, 33, 33,
        ],
        barThickness: 12,
      },
      {
        label: "High",
        borderColor: chartColors(2),
        backgroundColor: chartColors(2),
        data: [
          23, 26, 25, 25, 21, 23, 24, 29, 35, 38, 37, 42, 45, 43,
        ],
        barThickness: 12,
      },
      {
        label: "In debt distress",
        borderColor: chartColors(3),
        backgroundColor: chartColors(3),
        data: [
          12, 5, 6, 2, 0, 2, 3, 3, 9, 11, 12, 10, 12, 13,
        ],
        barThickness: 12,
      },
    ],
  },
  options: optionsStackedBar,
}

export default figure_1_5;
